<!--
 * @Author: MouXiaowei
 * @Date: 2022-11-10 15:34:06
 * @Description: 全国电子社保卡活动页面
-->

<template>
    <div class="esscs-box">
      <div>
        <img class="esscs-img" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/activeimg/esscs/esscs_content1.png"/>
        <img class="esscs-img" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/activeimg/esscs/esscs_content2.png"/>
      </div>
      <transition name="fade">
        <img class="go" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/activeimg/esscs/esscs_btn.png" @click="handlerJump"/>
      </transition>
    </div>
  </template>

<script>

export default {
  name: 'esscsActivity',
  data () {
    return {
      headerFixed: false
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.headerFixed = scrollTop > 50
    },
    handlerJump () {
      if (window._czc) {
        window._czc.push(['_trackEvent', '电子社保卡活动', '电子社保卡活动', '电子社保卡活动', '', '2036btn01'])
      }
      /* eslint-disable */
        dsBridge.call("callNativeViewLifeCycle", {
            appId: '130199998',
            authorize: 2,
            androidGoPage: '/module_social/EleCardActivity',
            iosGoPage: 'ESSCSWKServiceVC',
            appStartUrl: 'https://ssc.mohrss.gov.cn/main?',
            appType: 2
          })
        }
      }
    }
  </script>
  <style lang="scss" scoped>
    .esscs-box {
      padding-bottom: 55.5px;
    }
    .esscs-img {
      width: 100%;
    }
    .go {
      width: 100%;
      position: fixed;
      bottom: 0;
    }
    .fade-enter {
      opacity: 0;
    }
    .fade-enter-active {
      transition: opacity 0.8s;
    }
    .fade-leave-to {
      opacity: 0;
    }
    .fade-leave-active {
      transition: opacity 0.8s;
    }
  </style>
  